// 헤더 슬롯 포털 (내부) — HeaderLeft/HeaderRight 가 감싼다.
// props: id (포털 대상 DOM id), children
// 노드는 **effect 에서** 잡는다 — 렌더 중 setState 는 React 오류 301. 슬롯이 아직 없으면(테스트·초기 프레임) 아무것도 그리지 않는다.
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

function SlotPortal(props) {
  var st = useState(null);
  var node = st[0], setNode = st[1];
  useEffect(function () {
    setNode(typeof document !== 'undefined' ? document.getElementById(props.id) : null);
  }, [props.id, setNode]);
  if (!node) return null;
  return ReactDOM.createPortal(props.children, node);
}

export default SlotPortal;
